<template>
    <div id="materBinding">
        <el-form ref="searchForm" style="width:100%" :inline="true" :model="searchForm" :label-position="labelPosition">
            <el-form-item style="width:200px;margin-bottom:15px">
                <el-select filterable @change="selectBrand" v-model="searchForm.brandId" placeholder="品牌" clearable>
                    <el-option v-for="(item,index) in brandLists" 
                        :label="item.brandName" 
                        :value="item.brandId" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:200px;margin-bottom:15px">
                <el-select filterable @change="selectCategory" v-model="searchForm.categoryId" placeholder="品类" clearable>
                    <el-option v-for="(item,index) in categoryLists" 
                        :label="item.categoryName" 
                        :value="item.categoryId" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:200px;margin-bottom:15px">
                <el-select filterable @change="selectModel" v-model="searchForm.modelId" placeholder="型号" clearable>
                    <el-option v-for="(item,index) in modelLists" 
                        :label="item.modelName" 
                        :value="item.modelId" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:200px;margin-bottom:15px">
                <el-select filterable @change="selectFaultClass" v-model="searchForm.faultTypesId" placeholder="故障大类" clearable>
                    <el-option v-for="(item,index) in faultClassLists" 
                        :label="item.faultTypesName" 
                        :value="item.faultTypesId" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px">
                <el-select filterable @change="selectSubClass"  clearable v-model="searchForm.faultSubclassId" class="guzhang" placeholder="故障小类" style="width:240px;margin-bottom: 10px;margin-right: 10px">
                    <el-option v-for="item,index in faultLists"
                        :key="index" 
                        :label="item.faultSubclassName" 
                        :value="item.faultSubclassId">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-card class="box-card">
            <el-table
                :data="returnData"
                border
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    prop="modelName"
                    label="型号"
                    width="250">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="colorName"
                    label="颜色"
                    width="250">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialName"
                    label="物料名称">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialCode"
                    label="物料编号">
                </el-table-column>
                <el-table-column
                    align="center"
                    width="120"
                    label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="!scope.row.materialCode && basicsAuth.insertColorMaterial" @click.stop="createBtn(scope.$index, scope.row)" type="text" size="small" >新增</el-button>
                        <el-button v-if=" scope.row.materialCode &&  basicsAuth.updateColorMaterial" @click.stop="exitBtn(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-dialog :title="textMenu[dialogMenuStatus]" :visible.sync="dislogCreate" :close-on-click-modal="false" width="600px" @close="emptyDialog('materForm')">
            <el-form ref="materForm" :model="materForm" label-width="100px" :label-position="labelPosition">
                <el-form-item label="型号名称：">
                    <el-input v-model.trim="materForm.modelName" disabled></el-input>
                </el-form-item>
                <el-form-item label="颜色：">
                    <el-input v-model.trim="materForm.colorName" disabled></el-input>
                </el-form-item>
                <el-form-item label="物料名称：">
                    <el-select clearable  v-model.trim="materForm.materialCoding" placeholder="请选择物料名称" autocompelete="off" style="width: 100%;" filterable @change="getMaterialCode" >
                        <el-option 
                            :label="item.materialName" 
                            :value="item.materialCoding" 
                            v-for="(item,index) in MaterialLists" 
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物料编号：">
                    <el-input disabled v-model.trim="materForm.materialCode"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" >
                <el-button v-if="dialogMenuStatus!=='update'" type="success" @click="addEventFormSubmitBtn('materForm')">添加</el-button>
                <el-button v-else type="success" @click="saveEventFormSubmitBtn('materForm')">保存</el-button> 
                <el-button @click="emptyDialog('materForm')">取 消</el-button> 
            </span> 
        </el-dialog>
    </div>
</template>

<script>
    import {
        selectAllBrand,selectCategory,selectfaultTypes,selectFaultSubclass,selectMaterialBindingRelationship,selectMaterialManagements,insertColorMaterial,updateColorMaterial,selectModel
    } from "../../api/api";
     import {getPermission} from '../../api/authRequest'
    export default {
        name: 'materBinding',
        props: ['count'],
        data () {
            return {
                searchForm:{
                    brandId:'',
                    categoryId:'',
                    faultTypesId:'',
                    faultSubclassId:''
                },
                dialogMenuStatus: "",
                textMenu: {
                    update: "修改物料绑定",
                    create: "新增物料绑定"
                },
                labelPosition: 'left',
                faultClassLists:[],
                faultLists:[],
                brandLists:[],
                categoryLists:[],
                modelLists:[],
                MaterialLists:[],
                exitHtml:'编辑',
                allowExit:true,
                exitStatus:false,
                returnData: [],
                materForm:{
                    modelName: '', 
                    colorName: '', 
                    materialCoding: '', 
                    materialCode: '',
                },
                dislogCreate:false,
                // mapForChannel:this.count,
                basicsAuth:{
                    insertColorMaterial:false,
                    updateColorMaterial:false
                }
            }
        },
        created(){
            this.getBrandLists();
            this.getFaultTypesList();
            this.getMaterialManagementList();
        },
        mounted () {
            this.basicsAuth.insertColorMaterial= getPermission('/api/basicSetting/ModelFaultSolution/insertColorMaterial');
            this.basicsAuth.updateColorMaterial= getPermission('/api/basicSetting/ModelFaultSolution/updateColorMaterial');
        },
        methods: {
            //清空dialog
            emptyDialog(formName) {
                this.$refs[formName].resetFields();
                this.dislogCreate = false
            },
            //查询故障大类selectfaultTypes
            getFaultTypesList(){
                selectfaultTypes({}).then(res => {
                    if (res.data.status == 100) {
                        this.faultClassLists = res.data.results
                        this.getFaultList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },
            //选择故障分类
            selectFaultClass() {
                this.faultLists = [];
                this.getFaultList();
                this.searchForm.faultSubclassId = "";
                this.getRelationshipList();
            },
            //选择故障小类
            selectSubClass(){
                this.getRelationshipList()
            },
            //获取故障
            getFaultList(){
                selectFaultSubclass({faulttypesId:this.searchForm.faultTypesId}).then(res => {
                    if (res.data.status == 100) {
                        this.faultLists = res.data.results;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },
            //查询品牌or获取品牌
            getBrandLists() {
                selectAllBrand().then(res => {
                    if (res.data.status==100) {
                        this.brandLists = res.data.results;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //选中品牌
            selectBrand() {
                this.modelLists = [];
                this.getCategoryList();
                this.searchForm.categoryId = "";
                this.searchForm.modelId = "";
                this.getRelationshipList();
            },
            //获取品类
            getCategoryList(){
                selectCategory({brandId:this.searchForm.brandId}).then((res) => {
                    if (res.data.status == 100) {
                        this.categoryLists = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },
            //选中品类
            selectCategory() {
                this.getModelList();
                this.searchForm.modelId = "";
            },
            //选中型号
            selectModel() {
                this.getRelationshipList();
            },
            //机型型号
            getModelList(){
                let para={
                    brandId:this.searchForm.brandId,
                    categoryId:this.searchForm.categoryId
                };
                selectModel(para).then(res => {
                    if (res.data.status==100) {
                        this.modelLists = res.data.results;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            getRelationshipList(){
                let para = {
                    brandId:this.searchForm.brandId,
                    categoryId:this.searchForm.categoryId,
                    modelId:this.searchForm.modelId,
                    faultTypesId:this.searchForm.faultTypesId,
                    faultSubclassId:this.searchForm.faultSubclassId,
                }
                selectMaterialBindingRelationship(para).then((res) => {
                    if (res.data.status == 100) {
                        this.returnData = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },
            //新增物料
            createBtn(index,item){
                this.dislogCreate = true;
                this.materForm = Object.assign({}, item);
                this.dialogMenuStatus = "create";
            },
            //物料名称 物料编码的匹配
            getMaterialCode(e){
                if(e != '' && e != null){
                    this.MaterialLists.forEach((item,index)=>{
                        if(e === item.materialCoding){
                            this.materForm.materialCode = item.materialCode
                        }
                    })
                }else{
                    this.materForm.materialCode = "";
                }
            },
            //确认添加新物料
            addEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        // console.log(this.materForm)
                        let para={
                            modelFaultSolutionId: this.materForm.modelFaultSolutionId,
                            colorId: this.materForm.colorId,
                            materialCode: this.materForm.materialCode,
                        }
                        insertColorMaterial(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogCreate = false;
                                this.$refs[formname].resetFields();
                                /*刷新*/
                                this.getRelationshipList();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //编辑
            exitBtn(index,item) {
                // this.canSet = true
                this.dislogCreate = true
                this.dialogMenuStatus = "update";
                this.materForm = Object.assign({}, item);
                // console.log(this.materForm)
                var e = this.materForm.materialCode
                for (var i in this.MaterialLists) {
                    if (e === this.MaterialLists[i].materialCode) {
                        this.materForm.materialCoding = this.MaterialLists[i].materialName
                    }
                }
            },
            //确定保存
            saveEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        /*获取当前input上输入的文字*/
                        console.log(this.materForm)
                        let para={
                            colorMaterialId: this.materForm.colorMaterialId,
                            materialCode: this.materForm.materialCode,
                        }
                        updateColorMaterial(para).then(res => {
                            if (res.status===200) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogCreate = false;
                                this.$refs[formname].resetFields();
                                /*刷新*/
                                this.getRelationshipList();
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //获取物料编码 
            getMaterialManagementList() {
                selectMaterialManagements({}).then(res => {
                    if (res.data.status==100) {
                        this.MaterialLists = res.data.results
                        // console.log(res.data.results)
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            }
        },
        watch: {
      
        }
    }
</script>

<style lang="scss" type="text/css" scoped>
    #materBinding{
        .headerT{
            font-size: 16px;
            margin-bottom: 20px;
        }
        .content{
            display:flex;
        }
        .active {
            background: rgb(40, 165, 196);
        }
        .headerSpan{
            margin-right: 20px;
            display: block;
        }
        
        li.faultSub{
            height:75px !important;
            padding:10px
        }
        
        .listPart{    
            border: 1px solid #c6c6c6;
            margin: 10px 5px 10px 0;
            border-radius: 5px;
            text-align: center;
            position: relative;
            z-index: 0;
            cursor: pointer;
            padding: 5px 10px;
            width: 170px;
            font-size:14px
        }
        li.active{
            background-color:#1abc9c;
            color:#fff;
            border-color: #1abc9c;
        }
        .el-checkbox.is-bordered+.el-checkbox.is-bordered {
            margin-left: 15px;
        }
    }
</style>



// WEBPACK FOOTER //
// materBinding.vue?39d38a3b